import React from 'react';
import { SHEET_CODE_DESIGN_PAGE_WIDTH_PX, sanitizeSheetCodeHtml } from '../../utils/sheetCodeHtmlSanitize';

/**
 * 평가지 소스코드 블럭 정적 렌더 (스크립트 실행 없음, DOMPurify 정리 후 일반 DOM 으로 표시).
 * html2canvas 캡처(인쇄·PDF)에도 그대로 찍힙니다. A4 기준 폭(794px)으로 레이아웃 후 블럭 크기에 맞춰 축소/확대.
 */
const SlideCodeStaticHtml: React.FC<{ sourceCode: string; blockWidthNorm: number; transparent: boolean }> = ({
  sourceCode,
  blockWidthNorm,
  transparent,
}) => {
  const html = React.useMemo(() => sanitizeSheetCodeHtml(sourceCode), [sourceCode]);
  const hostRef = React.useRef<HTMLDivElement | null>(null);
  const [scale, setScale] = React.useState(1);
  const designW = Math.max(40, Math.round(SHEET_CODE_DESIGN_PAGE_WIDTH_PX * Math.max(0.02, blockWidthNorm)));

  React.useLayoutEffect(() => {
    const el = hostRef.current;
    if (!el) return;
    const update = () => {
      const w = el.clientWidth;
      if (w > 0) setScale(w / designW);
    };
    update();
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [designW]);

  return (
    <div
      ref={hostRef}
      className="cp-sheet-code-static"
      style={{ background: transparent ? 'transparent' : '#fff' }}
      aria-label="소스코드 블럭"
    >
      <div
        className="cp-sheet-code-static-inner"
        style={{ width: `${designW}px`, height: `${100 / (scale || 1)}%`, transform: `scale(${scale})`, transformOrigin: '0 0' }}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

export default SlideCodeStaticHtml;
